import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../core/api';
import { FeatureDetailsApiAccess } from '../features';

@Injectable({
  providedIn: 'root'
})
export class ExternalAPIsService {
  constructor(private readonly apiService: ApiService) {}

  put(payload: FeatureDetailsApiAccess): Observable<void> {
    return this.apiService.put('ExternalAPIs', payload);
  }
}
